export function transformOnelinkUrl(url: string, name: string): string {
  const isPixel = ['click_audit_pixel', 'pixel', 'pixel_additional', 'pixel_additional2'].includes(name);
  const isLink = name === 'link';
  
  // Если не Onelink или не link/pixel поле - возвращаем как есть
  if (!url.includes('onelink.me') || (!isLink && !isPixel)) {
    return url;
  }
  
  // Для pixel поля - без изменений
  if (isPixel) {
    return url;
  }
  
  // Для link поля - добавляем параметры
  if (isLink) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}s_trk={TR_KEY}&erid={ERID}`;
  }
  
  return url;
}